<template>
  <v-dialog v-model="dialog" width="500" transition="fab-transition">
    <v-card class="pl-0 pr-0" style="height:100%; width: 100%;">
      <v-card-title style="height:20%">
        <v-icon class="mr-3">fas fa-lock</v-icon>
        <span class="description-selected">
          Agregar Material
        </span>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-actions>
        <v-row style="width:100%; margin:0px;">
          <v-col cols="8">
            <v-autocomplete
              ref="inventory_id"
              v-model="form.inventory_id"
              :items="inventories"
              label="Material"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              :value="form.inventory_id"
              :loading="loading"
              v-on:keyup.enter="searchMaterial($event)"
              hide-details="auto"
              required
            ></v-autocomplete>

            <!-- <v-autocomplete
              ref="sedes"
              :value="form.inventory_id"
              v-model="form.inventory_id"
              :items="inventories"
              label="Material"
              outlined
              :item-text="customText"
              item-value="id"
              :rules="[
                () =>
                  !!form.inventory_id || 'Es necesario seleccionar un Material',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete> -->
          </v-col>
          <v-col cols="4">
            <v-text-field
              ref="cantidad"
              v-model="form.cantidad"
              label="Cantidad"
              outlined
              :rules="[
                () => !!form.cantidad || 'Es necesario ingresar una cantidad',
              ]"
              hide-details="auto"
              required
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-actions>

      <v-card-actions>
        <v-container class="pt-0 pb-0" style="height:115px;">
          <v-row style="padding-top:33px;">
            <v-col cols="6">
              <v-btn dark color="red" block @click="handleCancel">
                Cancelar
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn
                dark
                color="green"
                block
                :disabled="processing"
                @click="handleSaveAddMaterial()"
              >
                Aceptar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>

    <!-- <create-update ></create-update> -->
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

// import { CreateUpdate } from "./CreateUpdate"

export default {
  name: "AddAnalysisDetail",
  props: ["devolverData"],
  components: {
    // CreateUpdate
  },
  data() {
    return {
      dialog: false,
      processing: false,
      form: {
        inventory_id: null,
        cantidad: null,
      },
      loading: false,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getMaterialAll({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("material", ["inventories"]),
  },
  methods: {
    ...mapActions("material", ["getMaterialAll"]),
    customText(item) {
      let text = item.description;
      return text;
    },
    showDialog() {
      this.dialog = true;
      this.clearData();
    },
    clearData() {
      this.clearErrors();
    },
    handleCancel() {
      this.clearData();
      this.dialog = false;
    },
    handleSaveAddMaterial() {
      const { inventory_id, cantidad } = this.form;
      const inventory = this.inventories.find((i) => i.id == inventory_id);
      const newItem = { inventory, inventory_id, cantidad };
      this.devolverData(newItem);
      this.form = { inventory_id: null, cantidad: null };
      this.clearData();
      this.dialog = false;
    },
    handleTypeDinamic() {},
    existErrors() {
      let hasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.form[f]) hasErrors = true;
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    async searchMaterial(event) {
      this.loading = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getMaterialAll({ description: value });
      } else {
        await this.getMaterialAll();
      }
      this.loading = false;
    },
    clearErrors() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
  },
  created() {
    this.loading = true;
    this.getMaterialAll({
      paginated: true,
    })
      .then((res) => (this.loading = false))
      .catch((err) => (this.loading = false));
  },
};
</script>

<style>
.table-edit {
  height: 90px;
}
</style>
